export class NotificationsApi {
}
export var NotificationProcessStatus;
(function (NotificationProcessStatus) {
    NotificationProcessStatus[NotificationProcessStatus["Info"] = 0] = "Info";
    NotificationProcessStatus[NotificationProcessStatus["InProgress"] = 1] = "InProgress";
    NotificationProcessStatus[NotificationProcessStatus["Success"] = 2] = "Success";
    NotificationProcessStatus[NotificationProcessStatus["Failure"] = 3] = "Failure";
})(NotificationProcessStatus || (NotificationProcessStatus = {}));
//# sourceMappingURL=notifications.api.js.map